<template>
  <div>
    <AppAccordion
      class="box order-position"
      :init-is-open="!isMobile"
      :visible-btn="!!hasPositions && !isMobile"
      :mobile-open="isMobile && isOpenAccordion"
    >
      <div slot="header">
        <header class="box__header" :class="{ 'mb-20' : isMobile }">
          <h3 @click="isMobile && collapseAccordion()">Позиции в заказе</h3>

          <div class="buttons buttons--card-full">
            <VButton
              v-if="!!hasPositions && permissionAddPacking"
              :text="!isMobile ? 'Упаковать' : ''"
              icon="packaging"
              size="sm"
              @click.native="openModal('packaging')"
            />

            <slot name="header-buttons" />

            <VButton
              v-if="permissionCreatePosition"
              text="Создать позицию"
              icon="create"
              size="sm"
              color="primary-sm"
              @click.native="checkFillTechManager"
            />

            <DropdownMenu v-if="showDropdownMenu" :dropdown-is-modal="isModal" @closeModal="closeModal" @openModal="openModal">
              <slot name="buttons-modal" />
              <VButton
                v-if="permissionUpdatePosition"
                text="Редактировать"
                icon="edit"
                size="sm"
                @click.native="onClickEdit"
              />

              <VButton
                v-if="permissionCreatePositionTemplate"
                text="Создать шаблон"
                icon="create"
                size="sm"
                @click.native="openModal('create-template')"
              />

              <VButton
                v-if="permissionSetIndicators"
                text="Добавить индикаторы"
                icon="create"
                size="sm"
                @click.native="openModal('set-indicators')"
              />

              <VButton
                v-if="!!hasPositions && permissionCopyPosition"
                text="Копировать позицию"
                icon="copy"
                size="sm"
                @click.native="openModal('copy-position')"
              />

              <VButton
                v-if="permissionDestroyPosition && !positionConsignments.length"
                text="Удалить"
                icon="remove"
                size="sm"
                @click.native="openModal('position-delete')"
              />
            </DropdownMenu>
            <VButton
              v-if="isMobile"
              block="collapse"
              :class="{ open: isOpenAccordion }"
              @click.native="collapseAccordion"
              style="z-index: 2"
              :icon="{ name: 'arrow', dir: isOpenAccordion ? '0' : '180' }"
            />
          </div>
        </header>

        <NoContentBox
          v-if="!hasPositions"
          text="Позиция не создана"
        />

        <TabsSwiper
          v-if="hasPositions && !isMobile"
          class="tabs-swiper--border mb-30"
          :space-between="30"
        >
          <TabItem
            class="swiper-slide"
            v-for="(item, index) of tabsPositions"
            :key="item.id"
            :navItem="item"
            :is-active="activePositionIndex === index"
            @click.native="setActivePosition(index)"
          />
        </TabsSwiper>
        <TabsSelect
          v-else-if="hasPositions && isMobile"
          class="mt-20"
          @onSelectTab="onSelectTab"
          item-text="title"
          :selected-item-index="activePositionIndex"
          :tabs-list="tabsPositions"
        />
      </div>

      <div v-if="hasPositions">
        <!--  Внимание!!! При добавлении новых полей, нужно также прописывать -->
        <!--  правила валидации в файле spa/src/utils/production/position/validation.js -->
        <!--  (проверка в заказе перед перед передачей в статус на запуск)-->
        <PositionHeadForm
          ref="PositionHeadForm"
          :class="{ 'mt-20 mb-20': isMobile, 'mb-m': !isMobile }"
          :is-disabled="isDisabled"
          :is-disabled-for-shipped="isDisabledForShipped"
          :indicators="getIndicatorsPositionAndConsignments"
          :order-status-id="orderStatusId"
        />

        <PositionFormDetails
          v-if="!isMobile"
          v-model="modelFormData"
          class="mb-s"
          ref="positionFormRef"
          :typePosition="currentPosition.type"
          has-probes
          :isDisabled="isDisabled"
          :is-disabled-for-shipped="isDisabledForShipped"
          :order-status-id="orderStatusId"
          @copyNoteManufacture="copyNoteManufacture"
          @copyRelativeOrders="copyRelativeOrders"
          @copyNoteOTK="copyNoteOTK"
        />

        <PositionFormDetailsMobile
          v-else
          v-model="modelFormData"
          class="mt-s"
          ref="positionFormRef"
          :typePosition="currentPosition.type"
          has-probes
          :isDisabled="isDisabled"
          :is-disabled-for-shipped="isDisabledForShipped"
          :order-status-id="orderStatusId"
          @copyNoteManufacture="copyNoteManufacture"
          @copyRelativeOrders="copyRelativeOrders"
          @copyNoteOTK="copyNoteOTK"
        />

        <ButtonGroup
          v-if="!isDisabled"
          textBtnConfirm="Сохранить"
          textBtnReject="Отмена"
          btn-size="l"
          :loading="isLoading"
          @confirm="submitUpdatePosition"
          @reject="resetForm"
        />
      </div>
    </AppAccordion>

    <ModalPositionCreate v-if="isModal === 'create-position'" @close="closeModal" />
    <ModalPositionCopy v-if="isModal === 'copy-position'" @close="closeModal" :activePositionIndex="activePositionIndex"/>
    <!-- position delete -->
    <ModalConfirmation
      v-if="isModal === 'position-delete'"
      title="Уверены что хотите удалить позицию?"
      @confirm="positionDeleteHandler"
      @reject="closeModal"
    />
    <CreateTemplateFromPosition
      v-if="isModal === 'create-template'"
      :position="currentPositionActive"
      @close="closeModal"
    />
    <ModalPackaging
      v-if="isModal === 'packaging'"
      @reject="closeModal"
    />
    <ModalFillTechManager
      v-if="isModal === 'fill-tech-manager'"
      :order="order"
      @fillTechManager="fillTechManagerHandler"
      @reject="closeModal"
    />

    <ModalSetIndicators
      v-if="isModal === 'set-indicators'"
      is-position
      :id="currentPosition.id"
      :indicators="getCurrentPositionIndicators"
      @setIndicators="setIndicators"
      @reject="closeModal"
    />

    <ModalConfirmation
      v-if="isModal === 'article-changed'"
      title="Артикул изменен. Необходимо обновить Бланк ТЗ и Паспорт изделия на этапах партий!"
      only-btn-submit
      text-btn-confirm="Ок"
      @confirm="closeModal"
    />
  </div>
</template>

<script>
import AppAccordion from '@/components/ui/AppAccordion'
import ButtonGroup from '@/components/ui/ButtonGroup/ButtonGroup'
import ModalPositionCreate from '@/components/production/position/ModalPositionCreate.vue'
import ModalPositionCopy from '@/components/production/position/ModalPositionCopy.vue'
import NoContentBox from '@/components/production/NoContentBox'
import PositionFormDetails from '@/components/production/position/PositionFormDetails'
import PositionFormDetailsMobile from '@/components/production/position/PositionFormDetailsMobile'
import PositionHeadForm from '@/components/production/position/PositionHeadForm.vue'
import TabItem from '@/components/ui/TabsSwiper/TabItem'
import TabsSwiper from '@/components/ui/TabsSwiper/TabsSwiper'
import VButton from '@/components/simple/button/VButton'

import { mixinModal } from '@/mixins/modal/mixinModal'
import { mixinIsLoading } from '@/mixins/mixinIsLoading'

import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { formulaTotalWeight } from '@/utils/production/position/formulas'
import { fixedNumberCopy } from '@/utils/number'
import { prepareFormDataPosition } from '@/utils/production/position'
import { showAlertSuccess } from '@/utils/store/alert'
import { orderModel } from '@/entities/order'

// import { reclamationExternalModel } from '@/entities/reclamation-external'
import CreateTemplateFromPosition from '@/features/create-template-from-position/ui/CreateTemplateFromPosition.vue'
import DropdownMenu from '@/components/ui/DropdownMenu.vue'
import ModalConfirmation from '@/components/ui/Modal/ModalConfirmation.vue'
import TabsSelect from '@/components/ui/TabsSelect.vue'
import { mixinAccordion } from '@/mixins/mixinAccordion'
import ModalFillTechManager from '@/components/ui/Modal/Production/Consignment/ModalFillTechManager.vue'
import ModalPackaging from '@/components/ui/Modal/Production/ModalPackaging.vue'
import ModalSetIndicators from '@/components/ui/Modal/Production/ModalSetIndicators.vue'
import { getCurrentIndicators, getIndicatorsPositionConsignments } from '@/entities/order/model'
import { FLAG_ID_STAGE_SHIPPED } from '@/const'

export default {
  name: 'Positions',
  components: {
    ModalSetIndicators,
    TabsSelect,
    ModalPackaging,
    ModalFillTechManager,
    ModalConfirmation,
    DropdownMenu,
    CreateTemplateFromPosition,
    PositionHeadForm,
    AppAccordion,
    ButtonGroup,
    ModalPositionCreate,
    NoContentBox,
    PositionFormDetails,
    PositionFormDetailsMobile,
    TabItem,
    TabsSwiper,
    VButton,
    ModalPositionCopy
  },
  mixins: [mixinModal, mixinIsLoading, mixinAccordion],

  mounted () {
    this.setActivePosition(this.activePositionIndex)
    this.getPropertiesAll()
  },

  watch: {
    'modelFormData.article' (val) {
      if (!val) return
      this.setArticle(val)
    }
  },

  computed: {
    ...mapGetters('orderDetail', {
      order: 'order',
      positions: 'positions',
      currentPosition: 'currentPosition',
      isEditPosition: 'isEditPosition',
      totalDirtyWeightConsignments: 'totalDirtyWeightConsignments',
      activePositionIndex: 'activePositionIndex',
      tabsPositions: 'tabsPositions',
      positionConsignments: 'positionConsignments',
      currentPositionActive: 'currentPositionActive',
      orderStatusId: 'orderStatusId'
    }),
    ...mapGetters({
      productionMasterList: 'users/productionMasterList',
      countMaterialByArticle: 'warehouse/countMaterialByArticle'
    }),
    ...mapGetters('permission', [
      'permissionCreatePosition',
      'permissionCopyPosition',
      'permissionUpdatePosition',
      'permissionDestroyPosition',
      'permissionCreatePositionTemplate',
      'permissionPrintDocumentProduction',
      'permissionAddPacking',
      'permissionSetIndicators'
    ]),
    ...mapState('mobile', {
      isMobile: 'isMobile'
    }),

    modelFormData: {
      get () {
        const position = this.currentPosition
        if (position.type?.id === 3 && (position.tap_angle === undefined)) position.tap_angle = 0
        return position
      },
      set (newFormData) {
        this.SET_CURRENT_POSITION_VALUE({ value: newFormData })
      }
    },

    hasPositions () {
      return this.positions?.length
    },

    isDisabled () {
        let isValue = false
        if (this.positionConsignments) {
            this.positionConsignments.forEach(item => {
                if (item.value !== 0) isValue = true
            })
        }
        if (isValue && !this.isEditPosition) return true
        else return this.disabled || !this.isEditPosition
    },

    calcTotalWeight () {
      return formulaTotalWeight(this.modelFormData)
    },

    weightPosition () {
      let weightTotal = this.calcTotalWeight ? this.calcTotalWeight * this.modelFormData.value : 0
      if (weightTotal !== 0) {
        weightTotal = fixedNumberCopy(weightTotal, 2)
      }
      return weightTotal
    },
    // isCopyPosition () {
    //   if (!this.order?.is_outer_reclamation || !this.order?.from_outer_reclamation?.indicator || !this.permissionCopyPosition) {
    //     return false
    //   }
    //
    //   return reclamationExternalModel.isIndicatorForCopyPosition(this.order.from_outer_reclamation.indicator)
    // },
    showDropdownMenu () {
      return this.permissionUpdatePosition
        || this.isCopyPosition
        || this.permissionCreatePositionTemplate
        || (this.permissionDestroyPosition && !this.positionConsignments.length)
        || (this.isMobile && this.permissionPrintDocumentProduction)
    },

    // Получение установленных индикаторов для текущей позиции и её партий
    getIndicatorsPositionAndConsignments () {
      return getIndicatorsPositionConsignments(this.currentPosition)
    },

    // Получение установленных индикаторов для текущей позиции
    getCurrentPositionIndicators () {
      return getCurrentIndicators(this.currentPosition)
    },

    // Для позиций, где есть отгруженные (не рекламационные) партии дизейблить редактирование некоторых полей
    isDisabledForShipped () {
      return this.positionConsignments?.some(
        item => item?.status?.flag_id === FLAG_ID_STAGE_SHIPPED && !item?.is_inner_reclamation
      ) ?? false
    },
    // Проверяет, есть ли хотя бы одна партия со статусом, отличным от «отгружено»
    hasConsignmentsInWorkStatuses () {
      return this.positionConsignments?.some(
        item => item?.status?.flag_id !== FLAG_ID_STAGE_SHIPPED
      ) ?? false
    }
  },

  methods: {
    ...mapMutations({
      setArticle: 'warehouse/SET_ARTICLE'
    }),
    ...mapMutations('orderDetail', [
      'SET_CURRENT_POSITION',
      'SET_CURRENT_POSITION_VALUE',
      'SET_CURRENT_POSITION_CANCEL_EDIT',
      'SET_CURRENT_POSITION_FILES_DELETE',
      'TOGGLE_IS_EDIT_POSITION',
      'UPDATE_ORDER',
      'SET_CURRENT_POSITION_INDICATORS'
    ]),
    ...mapActions('orderDetail', [
      'updatePositionCurrent',
      'setActivePosition',
      'removePosition'
    ]),

    ...mapActions({
      getPropertiesAll: 'records/getPropertiesAll'
    }),

    async submitUpdatePosition () {
      if (this.hasValidErrors()) return

      try {
        this.startLoading()

        // Сохраняем старый артикул (до обновления)
        const oldArticle = this.currentPositionActive?.article || null

        const data = {
          ...this.modelFormData,
          ...prepareFormDataPosition(this.modelFormData)
        }
        await this.updatePositionCurrent(data)

        // Получаем новый артикул из отправленных данных
        const newArticle = this.modelFormData.article
        const articleChanged = oldArticle && newArticle && oldArticle !== newArticle

        // Проверяем, изменился ли артикул и есть ли партии в работе, вызываем модалку
        if (articleChanged && this.hasConsignmentsInWorkStatuses) {
          this.openModal('article-changed')
        }

        this.modelFormData.files = this.currentPosition.files

        showAlertSuccess('Позиция обновлена')
      } finally {
        this.finishLoading()
      }
    },

    hasValidErrors () {
      let error = false
      if (this.$refs.PositionHeadForm.$refs.Form.hasValidationErrors()) {
        error = true
      }

      if (this.$refs.positionFormRef.$refs.positionFormRef.hasValidationErrors()) {
        error = true
      }

      return error
    },

    clearForm () {
      this.$refs.PositionHeadForm.$refs.Form.clear()
      this.$refs.positionFormRef.$refs.positionFormRef.clear()
    },

    resetForm () {
      this.SET_CURRENT_POSITION_CANCEL_EDIT()
      this.$emit('cancelEdit')
      this.modelFormData = { ...this.currentPosition }
      this.clearForm()
    },

    validationPositionValue (value) {
      const consignments = this.modelFormData.consignments
      if (!consignments?.length) return true

      const consignmentsValue = consignments.reduce((prev, current) => {
        return prev + current.value
      }, 0)

      return +value >= consignmentsValue
    },

    copyRelativeOrders () {
      const relationOrders = orderModel.getRelationOrders(this.order)
      let text = 'Ранее деланные заказы: '
      if (!relationOrders.length) text = text + '-; '
      else {
        relationOrders.forEach(order => {
            text = text + order.account_number + '; '
        })
      }
      this.setComment(text)
    },

    copyNoteManufacture () {
      let note
      if (!this.order.note_manufacture) note = '-; '
      else note = this.order.note_manufacture + '; '
      this.setComment(note)
    },

    setComment (text) {
      if (!this.modelFormData.comment) this.modelFormData.comment = ''
      this.modelFormData.comment = `${this.modelFormData.comment} ${text}`.trim()
    },

    copyNoteOTK () {
        let otk
        if (!this.order.note_otk) otk = '-; '
        else otk = this.order.note_otk + '; '
        this.setNoteOTK(otk)
    },

    setNoteOTK (text) {
      if (!this.modelFormData.note_otk) this.modelFormData.note_otk = ''
      this.modelFormData.note_otk = `${this.modelFormData.note_otk} ${text}`.trim()
    },

    // Position
    async positionDeleteHandler () {
      try {
        this.$store.commit('SET_IS_SENDING_REQUEST_MODAL')
        await this.removePosition()
      } finally {
        this.$store.commit('SET_IS_SENDING_REQUEST_MODAL', false)
        this.closeModal()
      }
    },

    onClickEdit () {
      // На первом этапе заказа сбрасываем длину развертки при редактировании позиции
      if (this?.order?.status_id === 1) this.modelFormData.sweep_length = null
      this.TOGGLE_IS_EDIT_POSITION()
      this.closeModal()
    },

    onSelectTab (item) {
      this.tabsPositions.forEach((elem, key) => {
        if (item.id === elem.id) {
          this.setActivePosition(key)
        }
      })
    },

    checkFillTechManager () {
      if (!this.order.tech_manager) {
        this.openModal('fill-tech-manager')
      } else {
        this.openModal('create-position')
      }
    },

    async fillTechManagerHandler (data) {
      this.UPDATE_ORDER(data)

      this.openModal('create-position')
    },

    // // После успешной установки индикаторов закрываем модальное окно и выполняет setIndicators
    async setIndicators (data) {
      this.closeModal()
      this.SET_CURRENT_POSITION_INDICATORS(data)
    }
  }
}
</script>
